import { isMobile } from '../utilities/check-device-resolution';

const $selectMenu = $('.js-select-menu');

/**
 * Event listeners
 */
$selectMenu.on('click', 'a, button', function(event) {
  const $this = $(this);
  const href = $this.attr('href');

  if ($this.hasClass('js-select-menu-btn') && isMobile()) {
    $selectMenu.toggleClass('is-active');
    return;
  }

  if (href != '#') {
    window.location.href = href;
  }
});

$(document).on('click', function (event) {
  if (!$(event.target).closest('.js-select-menu').length && isMobile()) {
    $('.js-select-menu').removeClass('is-active');
  }
});
